






































































































import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import {
    DeleteSysBasic,
    GetDicItemByCode,
    GetListByCode,
    InsertSysBasic,
} from "@/api/configureDictionary";
import { GetDocTemplateByName, SaveDocTemplate } from "@/api/hd";
import UE from "@/components/ueditor/index.vue";
import { DefaultConfig } from "@/components/ueditor/config";
import { GetPinYin, GetWuBi } from "@/api/sys";
@Component({
    components: {
        UE,
    },
})
export default class extends AbpBase {
    docTypeList: any = []; //文书类型
    typeLoading = false;
    docLoading = false;
    currentType: any = null; //当前选中文书类型
    docContent: string = "";
    //UEditor富文本编辑器配置参数
    ueditorConfig: any;
    addTypeShow = false;
    dialogForm: any = {};
    dialogFormLabelWidth = "100px";
    parentDic: any = null;
    rules = {
        name: [{ required: true, message: "请输入内容", trigger: "blur" }],
        py: [{ required: true, message: "请输入内容", trigger: "blur" }],
        wb: [{ required: true, message: "请输入内容", trigger: "blur" }],
    };

    created() {
        this.ueditorConfig = DefaultConfig;
        this.ueditorConfig.initialFrameHeight = this.tableHeight - 120;
        this.getParentDic();
        this.getTypeList();
    }

    async getParentDic() {
        let res = await GetDicItemByCode({ code: "032" });
        this.parentDic = res;
    }

    //表格高度
    get tableHeight() {
        return window.innerHeight - 130;
    }

    async getTypeList() {
        this.typeLoading = true;
        let res = await GetListByCode({ input: "032" });
        this.docTypeList = res;
        this.typeLoading = false;
    }

    async typeChange(row: any) {
        this.currentType = row;
        await this.getData();
       // await this.save();
    }

    async getData() {
        if (!this.currentType) {
            return;
        }
        this.docLoading = true;
        let res = await GetDocTemplateByName({
            docName: this.currentType.text,
        });
        if (res.objects) {
            this.docContent = res.objects.docContent;
        } else {
            this.docContent = "";
        }
        this.docLoading = false;
    }

    resetTemp() {
        this.getData();
    }

    async save() {
        if (!this.currentType) {
            return;
        }
        this.docLoading = true;
        var res =await SaveDocTemplate({
            docName: this.currentType.text,
            docContent: (this.$refs.ueditor1 as any).getUEContent(),
        });
        if (res) {
          //更新缓存
          let res = await GetListByCode({ input: "032" });
          this.docTypeList = res;
        }
        this.docLoading = false;
    }

    addType() {
        if (!this.parentDic) {
            return;
        }
        this.dialogForm = {
            code: Date.now(),
            parentId: this.parentDic.id,
            py: "",
            wb: "",
        };
        this.addTypeShow = true;
    }

    delType(row: any) {
        this.$Modal.confirm({
            title: "提示",
            content: "确定要删除吗？",
            onOk: async () => {
                await DeleteSysBasic({ id: row.id });
                await this.getTypeList();
                if (this.currentType == row) {
                    this.currentType = null;
                    this.docContent = "";
                }
            },
        });
    }

    visibleChange(val: any) {
        if (!val) {
            this.addTypeShow = false;
            (this.$refs.form as any).resetFields();
        }
    }

    async confirm() {
        (this.$refs.form as any).validate(async (valid: boolean) => {
            if (valid) {
                await InsertSysBasic(this.dialogForm);
                this.addTypeShow = false;
                this.getTypeList();
            }
        });
    }

    async getCode(val: any) {
        let query = { inputStr: val };
        let res1 = await GetPinYin(query);
        let res2 = await GetWuBi(query);
        this.dialogForm.py = res1;
        this.dialogForm.wb = res2;
    }
    ellipsis (value: any) {
      if (!value) return ''
      if (value.length > 12) {
        return value.slice(0,12) + '...'
      }
      return value
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tempManage/docTemp/index.vue